import { useEffect } from 'react';

// Bootstrap Icons webfont, CDN-loaded and pinned (SRI) — staff routes only, so
// the public pages never make this request. CSS + font only, no third-party JS.
const ICONS_HREF =
  'https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css';
const ICONS_SRI = 'sha384-XGjxtQfXaH2tnPFa9x+ruJTuLE3Aa6LhHSWRr1XeTyhezb4abCG4ccI5AkVDxqC+';

export function useStaffIcons() {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = ICONS_HREF;
    link.integrity = ICONS_SRI;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
    return () => link.remove();
  }, []);
}

/** Decorative icon. The button around it must carry the aria-label. */
export function Icon({ name }: { name: string }) {
  return <i className={`bi bi-${name}`} aria-hidden="true" />;
}
